import React from 'react';

import { Box, Button, Icon, Text } from '@betterment/samba-react';

import { useCoPilotSectionState } from '../../contexts/CoPilotSectionContext';
import { AccountApproval } from '../../services/api/types/co_pilot/account_approvals';

const ErrorSection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { refresh } = useCoPilotSectionState<AccountApproval>();
  return (
    <Box css={{ display: 'grid', placeItems: 'center' }}>
      <Icon name="ExclamationCircle" size="small" color="icon.critical" />
      <Text color="text.weak" css={{ textAlign: 'center', mt: 2 }}>
        Something went wrong and we weren’t able to retrieve any results
      </Text>
      <Button variant="textPrimary" onClick={() => refresh()}>
        Refresh the page
      </Button>
    </Box>
  );
};

export default ErrorSection;
